import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBJumbotron, MDBFormInline } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Checkbox, message, Select,Icon  } from 'antd';

import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Swal from 'sweetalert2/dist/sweetalert2.js'
//import Login from './Login';
import Axios from 'axios'
import { api, URL } from '../api';
import logo from './img/logokpru.png'
import background from "./img/5543.jpg";
var md5 = require('md5');
const FormItem = Form.Item;

//import Swal from 'sweetalert2'

export default class Register2 extends Component {
    


        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,
                radio: "",

                Educationlevel:[],
                prefix:[],
                province:[],
                district:[],
                subdistrict:[],


                Studentcb_ID:'',

                Studentcb_ID_NO:'', //รหัสนักศึกษา
                Studentcb_Citizen_ID:'',
                Studentcb_PASSWORD:'', //รหัสผ่าน
                Studentcb_PASSWORD2:'',//ยืนยันรหัสผ่าน
                Studentcb_PNAME:'',
                Studentcb_NAME:'',
                Studentcb_LASTNAME:'',
                Studentcb_ADDRESS:'',
                Studentcb_PROVINCE:'',
                Studentcb_DISTRICT:'',
                Studentcb_SUBDISTRICT:'',
                Studentcb_ZIPCODE:'', 
                Studentcb_TEL:'',
                Studentcb_EMAIL:'',
                Studentcb_Education_LEVEL:'',
                Studentcb_SCHOOL:'',
                Studentcb_DB:'',
                Studentcb_STATUS:'',
                Univ_ID:'',
                Edu_ID:'',

                typeregister: "",

            };

          //  this.handleChange = this.handleChange.bind(this);
           // this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getprefix = this.getprefix.bind(this);
            this.onChange = this.onChange.bind(this);
            this.onChange2 = this.onChange2.bind(this);
            this.getprovince = this.getprovince.bind(this);
            this.onChangeprovince = this.onChangeprovince.bind(this);
            this.onChangedistrict = this.onChangedistrict.bind(this);
            this.getzipcode = this.getzipcode.bind(this);
            this.onClickradio = this.onClickradio.bind(this);
            this.backtohome = this.backtohome.bind(this);   
            this.onClicktype = this.onClicktype.bind(this);     
          }

          onClicktype = (nr) => () => {
            this.setState({
              typeregister: nr,
            });
            if (nr === 1) {
              this.setState({
                Studentcb_Education_LEVEL: 4,
                Studentcb_SCHOOL: 'มหาวิทยาลัยราชภัฏกำแพงเพชร',
              });
            }else{
              this.setState({
                Studentcb_Education_LEVEL: '',
                Studentcb_SCHOOL: '',
              });
            }

          };
        

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          onClickradio = (nr) => () => {
            this.setState({
              radio: nr,
            });
          };

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }


          onTextChange = (e) => {

            this.setState({ [e.target.name]: e.target.value })
          }

//ชุด function select
          //คำนำหน้า
           onChange(value) {
            console.log(`selected ${value.target.value}`);
            this.setState({ Studentcb_PNAME: value.target.value })
          }

          onChange2(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_Education_LEVEL: value.target.value  })
          }
          //จังหวัด
          onChangeprovince(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_PROVINCE: value.target.value  })

                  api.get('index/getdistrict/'+value.target.value ,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                    // console.log(res.data[0].id)
                  //  console.log(res.data)
                    // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                  //  console.log(Course)
                      const district = res.data;
                      this.setState({ district });
                  }) 
          }

          //อำเภอ
          onChangedistrict(value) {
            console.log(`selected ${value.target.value }`);
            this.setState({ Studentcb_DISTRICT: value.target.value  })

                  api.get('index/getsubdistrict/'+value.target.value ,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                    // console.log(res.data[0].id)
                  //  console.log(res.data)
                    // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                  //  console.log(Course)
                      const subdistrict = res.data;
                      this.setState({ subdistrict });
                }) 
          }
          

    

      //    รหัสไปรษณีย์
          getzipcode(value) {
            console.log(`selected ${value.target.value }`);
            this.setState({ Studentcb_SUBDISTRICT: value.target.value  })

         //  const dis = this.state.subdistrict.filter( ({ SUB_DISTRICT_ID }) => SUB_DISTRICT_ID === value );

         //  console.log(dis);
          // this.setState({ Studentcb_ZIPCODE : dis.ZIPCODE });

                  api.get('index/getzipcode/'+value.target.value ,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                     console.log(res.data[0].ZIPCODE)
                  //  console.log(res.data)
                    // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                  //  console.log(Course)
                      const fd = res.data[0].ZIPCODE;
                      this.setState({ Studentcb_ZIPCODE: fd});
                     // this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });
                }) 
          }

    


          
           onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }
//ชุด function select

          componentDidMount(){
             
                        api.get('index/getEducationlevel',
                         //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                         {headers: {
                           // Authorization: 'Bearer ' + localStorage.getItem('myData')
                         }
                         })
                         //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                         .then(res => {
                            // console.log(res.data[0].id)
                          //  console.log(res.data)
                           // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                             const Educationlevel = res.data;
                             this.setState({ Educationlevel });
                         })  
                    this.getprefix();    
                    this.getprovince();
             }

          getprefix() {
                     api.get('index/getprefix',
                         {headers: {
                           // Authorization: 'Bearer ' + localStorage.getItem('myData')
                         }  })
                         .then(res => {
                            // console.log(res.data[0].id)
                          //  console.log(res.data)
                           // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                             const prefix = res.data;
                             this.setState({ prefix });
                       }) 
            }

          getprovince() {
              api.get('index/getprovince',
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                     // console.log(res.data[0].id)
                   //  console.log(res.data)
                    // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                   //  console.log(Course)
                      const province = res.data;
                      this.setState({ province });
                }) 
          }

        
        //  handleChange(event) {    this.setState({value: event.target.value});  }
         // handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

       

          handleSubmit = (e) => {
            e.preventDefault();
            // alert('A name was submitted: ' + this.state.value);
         
            api.get('index/checkregister/'+this.state.Studentcb_Citizen_ID,
            {headers: {
              // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }  })
            .then(res => {
              if (res.data.length === 0) {
                
                setTimeout(() => {
        
                  const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                  datafrm.append("Studentcb_Citizen_ID", this.state.Studentcb_Citizen_ID);
                  datafrm.append("Studentcb_PNAME", this.state.Studentcb_PNAME);
                  datafrm.append("Studentcb_NAME", this.state.Studentcb_NAME);
                  datafrm.append("Studentcb_LASTNAME", this.state.Studentcb_LASTNAME);
                  datafrm.append("Studentcb_DB", this.state.Studentcb_DB);
                  datafrm.append("Studentcb_PASSWORD", this.state.Studentcb_PASSWORD);
                  datafrm.append("Studentcb_DBMD5", md5(this.state.Studentcb_PASSWORD));
                  datafrm.append("Studentcb_ADDRESS", this.state.Studentcb_ADDRESS);
                  datafrm.append("Studentcb_PROVINCE", this.state.Studentcb_PROVINCE);
                  datafrm.append("Studentcb_DISTRICT", this.state.Studentcb_DISTRICT);
                  datafrm.append("Studentcb_SUBDISTRICT", this.state.Studentcb_SUBDISTRICT);
                  datafrm.append("Studentcb_ZIPCODE", this.state.Studentcb_ZIPCODE);
                  datafrm.append("Studentcb_TEL", this.state.Studentcb_TEL);
                  datafrm.append("Studentcb_EMAIL", this.state.Studentcb_EMAIL);
                  datafrm.append("Studentcb_Education_LEVEL", this.state.Studentcb_Education_LEVEL);
                  datafrm.append("Studentcb_SCHOOL", this.state.Studentcb_SCHOOL);
                  datafrm.append("Studentcb_ID_NO", this.state.Studentcb_ID_NO);
                  datafrm.append("Studentcb_TYPE", this.state.typeregister);
                 // datafrm.append("Univ_ID", this.state.Univ_ID);
                  
               Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddStudentRegister/",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
               })
            
               .then(res => {
                //    console.log(res);
                    if (res.status === 200) {
                    //  alert("บันทึกสำเร็จ")
                              Swal.fire({
                                  title: 'บันทึกข้อมูลสำเร็จ',
                                  icon: 'success',
                                // showCancelButton: true,
                                  confirmButtonText: 'ตกลง',
                                // cancelButtonText: 'No, keep it'
                                }).then((result) => {
                                    window.location.href = '/creditbank/Login'
                                  
                                })
                             }
                    })
                    //  this.getteacherforcurriculum();
                   // this.toggle()
                  //  this.props.getclassroom()
            
               }, 1000); 
    

              }else{
                          Swal.fire({
                            title: 'เลขประจำตัวประชาชนนี้ได้ลงทะเบียนแล้ว',
                            text: "กรุณาตรวจสอบอีกครั้ง",
                            icon: 'warning',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                          
                          })

              }

            }) 



          
      //  window.location.href = '/Register'
        //this.props.updateat();
        //this.getExpert()
         
          }
      
    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }

    backtohome() {
        // window.location.href = '/Register'
         window.location.href = '/creditbank/'
         // this.setState({Register
         //   collapse: !this.state.collapse,
         // });
       }

    render() {

     // console.log(this.state.Edu_ID)
      console.log(this.state.Studentcb_Citizen_ID)
      console.log(this.state.Studentcb_PNAME)
      console.log(this.state.Studentcb_NAME)
      console.log(this.state.Studentcb_LASTNAME)
      console.log(this.state.Studentcb_DB)
      console.log(md5(this.state.Studentcb_DB))
      console.log(this.state.Studentcb_ADDRESS)
      console.log(this.state.Studentcb_PROVINCE)
      console.log(this.state.Studentcb_DISTRICT)
      console.log(this.state.Studentcb_SUBDISTRICT)
      console.log(this.state.Studentcb_ZIPCODE)

      console.log(this.state.Studentcb_TEL)
      console.log(this.state.Studentcb_EMAIL)
      console.log(this.state.Studentcb_Education_LEVEL)
      console.log(this.state.Studentcb_SCHOOL)

        console.log(this.state.typeregister)
        console.log(this.state.Studentcb_ID_NO)
      

      const { Option } = Select;
     
        return (
       
                <MDBContainer >
 <img src={background} className="rounded mx-auto d-block w-100" alt="aligment" />   
                <MDBJumbotron >
  
                        <MDBContainer >
                        <h2 className="display-5 deep-purple-text text-center">ลงทะเบียน {this.state.Course_Name_TH}</h2>
                      
          <form onSubmit={this.handleSubmit} >
            <div id="pdfdiv">
              

                          <div className="mb-2">
                          <label className="font-weight-bold">ประเภทผู้ลงทะเบียน</label>
                          <MDBFormInline>
                                <MDBInput
                                  gap
                                  onClick={this.onClicktype(1)}
                                  checked={this.state.typeregister === 1 ? true : false}
                                  label="นักศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร"
                                  type="radio"
                                  id="radio1"
                                  containerClass="mr-5"
                                />
                                <MDBInput
                                  gap
                                  onClick={this.onClicktype(2)}
                                  checked={this.state.typeregister === 2 ? true : false}
                                  label="บุคคลทั่วไป"
                                  type="radio"
                                  id="radio2"
                                  containerClass="mr-5"
                                />
                            
                              </MDBFormInline>
                          </div>
                        
                            {this.state.typeregister === 1 ?<>
                               <div className="mb-2">
                                <label className="font-weight-bold">รหัสนักศึกษา</label>
                                <input className="form-control" onChange={this.onTextChange} maxLength={9} minLength={9} name="Studentcb_ID_NO"
                                    value={this.state.Studentcb_ID_NO} placeholder="กรุณาระบุ รหัสนักศึกษา" required />
                            </div>
                            </>:<></>}
                        

                           <div className="mb-2">
                                <label className="font-weight-bold">เลขประจำตัวประชาชน 13 หลัก</label>
                                <input className="form-control" onChange={this.onTextChange} maxLength={13} minLength={13} name="Studentcb_Citizen_ID"
                                    value={this.state.Studentcb_Citizen_ID} placeholder="กรุณาระบุ เลขประจำตัวประชาชน" required />
                            </div>

                            {this.state.typeregister === 2 ?<>
                            <div className="mb-2">
                                <label  className="font-weight-bold">password</label>
                                <input className="form-control" onChange={this.onTextChange} name="Studentcb_PASSWORD"
                                    value={this.state.Studentcb_PASSWORD} placeholder="กรุณาระบุ password" required />
                            </div>

                            <div className="mb-2">
                                <label  className="font-weight-bold">ยืนยัน password</label> {this.state.Studentcb_PASSWORD === this.state.Studentcb_PASSWORD2 ?<></>:<><label className="red-text">กรุณายืนยันรหัสผ่านให้ตรงกัน</label></>}  
                                <input className="form-control" onChange={this.onTextChange} name="Studentcb_PASSWORD2"
                                    value={this.state.Studentcb_PASSWORD2} placeholder="กรุณาระบุ password" required />
                            </div>
                            </>:<></>}
                            {/* <div className="mb-2">
                                <label>คำนำหน้า</label><br/>
                                <Select
                                        showSearch
                                        style={{ width: "100%" }}
                                        placeholder="--เลือกคำนำหน้า--"
                                        optionFilterProp="children"
                                        onChange={this.onChange}
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        onSearch={this.onSearch}
                                        filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                      
                                    
                                    {this.state.prefix.map((prefix,index )  => 
                                    <option value={prefix.PREFIX_NAME_ID}>{prefix.FULLNAME}</option>
                                    )}
                                    </Select>
                            </div> */}
                            
                            <div className="form-group mb-2">
                                <label className="font-weight-bold" htmlFor="example2">คำนำหน้า</label>
                                <div>
                                <select  className="form-control" value={this.state.Studentcb_PNAME} name="Edu_ID" onChange={this.onChange} >
                                                <option >เลือกคำนำหน้า</option>
                                                {this.state.prefix.map((prefix) => {
                                                    return <option value={prefix.PREFIX_NAME_ID}>{prefix.FULLNAME}</option>
                                                })}
                                </select>
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="font-weight-bold">ชื่อ</label>
                                <input className="form-control" onChange={this.onTextChange} name="Studentcb_NAME"
                                    value={this.state.Studentcb_NAME} placeholder="กรุณาระบุ ชื่อ" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold">นามสกุล</label>
                                <input className="form-control" onChange={this.onTextChange}  name="Studentcb_LASTNAME"
                                    value={this.state.Studentcb_LASTNAME} placeholder="กรุณาระบุ นามสกุล" required />
                            </div>
                            <div className="mb-2">
                                <label className="font-weight-bold">วันเดือนปีเกิด</label>
                                <input className="form-control" onChange={this.onTextChange}  name="Studentcb_DB"
                                    value={this.state.Studentcb_DB} placeholder="ตัวอย่าง 09/10/64" required />
                            </div>
                            <div className="form-group">
                                <label className="font-weight-bold" htmlFor="example2">ที่อยู่</label>
                                {/* <Input placeholder="ที่อยู่" value={this.state.Studentcb_ADDRESS} name="Studentcb_ADDRESS" onChange={this.onTextChange} required  /> */}
                                <input type="text" id="example2"  placeholder="ที่อยู่" className="form-control form-control-md" value={this.state.Studentcb_ADDRESS} name="Studentcb_ADDRESS"  onChange={this.onTextChange}  required />
                            </div>
                            <div className="form-group">
                                <label className="font-weight-bold" htmlFor="example2">จังหวัด</label>
                                <div>
                                <select  className="form-control" value={this.state.Studentcb_PROVINCE} name="Edu_ID" onChange={this.onChangeprovince} >
                                                <option >จังหวัด</option>
                                                {this.state.province.map((province) => {
                                                    return <option value={province.PROVINCE_ID}>{province.PROVINCE_NAME_TH}</option>
                                                })}
                                </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="font-weight-bold" htmlFor="example2">อำเภอ</label>
                                <div>
                                <select  className="form-control" value={this.state.Studentcb_DISTRICT} name="Edu_ID" onChange={this.onChangedistrict} >
                                                <option >อำเภอ</option>
                                                {this.state.district.map((district) => {
                                                    return <option value={district.DISTRICT_ID}>{district.DISTRICT_NAME_TH}</option>
                                                })}
                                </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="font-weight-bold" htmlFor="example2">ตำบล</label>
                                <div>
                                <select  className="form-control" value={this.state.Studentcb_SUBDISTRICT} name="Edu_ID" onChange={this.getzipcode} >
                                                <option >ตำบล</option>
                                                {this.state.subdistrict.map((subdistrict) => {
                                                    return <option value={subdistrict.SUB_DISTRICT_ID}>{subdistrict.SUB_DISTRICT_NAME_TH}</option>
                                                })}
                                </select>
                                </div>
                            </div>
           


              {/* <div className="form-group">
                    <label htmlFor="example2">ตำบล</label>
                  
                    <div>
                        <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="--ตำบล--"
                        optionFilterProp="children"
                        onChange={this.getzipcode}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                    
                    
                    {this.state.subdistrict.map((subdistrict,index )  => 
                    <option value={subdistrict.SUB_DISTRICT_ID}>{subdistrict.SUB_DISTRICT_NAME_TH}</option>
                    )}
                    </Select>
                  
                    </div>
              </div> */}
              <div className="form-group">
                 <label className="font-weight-bold" htmlFor="example2">รหัสไปรษณีย์</label>
                 {/* <Input placeholder="รหัสไปรษณีย์" value={this.state.Studentcb_ZIPCODE} name="Studentcb_ZIPCODE" onChange={this.onTextChange} required  /> */}
                 <input type="text" id="example2" placeholder="รหัสไปรษณีย์" className="form-control form-control-md" value={this.state.Studentcb_ZIPCODE} name="Studentcb_TEL"  onChange={this.onTextChange}  required />
             </div>
                      
             <div className="form-group">
                 <label className="font-weight-bold" htmlFor="example2">เบอร์โทร</label>
                 {/* <Input placeholder="เบอร์โทร" value={this.state.Studentcb_TEL} name="Studentcb_TEL" onChange={this.onTextChange} required  /> */}
                 <input  type="text" id="example2" placeholder="เบอร์โทร" className="form-control form-control-md" value={this.state.Studentcb_TEL} name="Studentcb_TEL"  onChange={this.onTextChange}  required />
             </div>
             <div className="form-group">
                 <label className="font-weight-bold" htmlFor="example2">อีเมลล์</label>
                 {/* <Input placeholder="อีเมลล์"  type="email" value={this.state.Studentcb_EMAIL} name="Studentcb_EMAIL" onChange={this.onTextChange} required  /> */}
                 <input type="email" id="example2" placeholder="อีเมลล์" className="form-control form-control-md" value={this.state.Studentcb_EMAIL} name="Studentcb_EMAIL"  onChange={this.onTextChange}  required />
             </div>
             
             <div className="form-group">
                 <label className="font-weight-bold" htmlFor="example2">ระดับการศึกษา</label>
                 <div>
                 <select  className="form-control" value={this.state.Studentcb_Education_LEVEL} name="Edu_ID" onChange={this.onChange2} >
                                <option >เลือกระดับการศึกษา</option>
                                {this.state.Educationlevel.map((data) => {
                                    return <option value={data.Edu_ID}>{data.Edu_name}</option>
                                })}
                 </select>
                 </div>
             </div>

             {/* <div className="form-group">
                    <label htmlFor="example2">ระดับการศึกษา</label>
                   
                    <div>
                        <Select
                        showSearch
                        style={{ width: "100%" }}
                        placeholder="-- เลือกระดับการศึกษา --"
                        optionFilterProp="children"
                        onChange={this.onChange2}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                       
                    
                    {this.state.Educationlevel.map((data,index )  => 
                    <option value={data.Edu_ID}>{data.Edu_name}</option>
                    )}
                    </Select>
                  
                    </div>
             </div> */}

           
             <div className="form-group">
                 <label className="font-weight-bold" htmlFor="example2">โรงเรียน/สถาบัน</label>
                 {/* <Input placeholder="โรงเรียน/สถาบัน" value={this.state.Studentcb_SCHOOL} name="Studentcb_SCHOOL" onChange={this.onTextChange} required  /> */}
                 <input type="text" id="example2" placeholder="โรงเรียน/สถาบัน" className="form-control form-control-md" value={this.state.Studentcb_SCHOOL} name="Studentcb_SCHOOL"  onChange={this.onTextChange}  required />
             </div>

             <div className="text-center form-group ">
             <MDBFormInline >
             <MDBInput
          gap
          onClick={this.onClickradio(1)}
          checked={this.state.radio === 1 ? true : false}
          label="ท่านยืนยันว่าตรวจสอบข้อมูลถูกต้องครบถ้วนแล้ว"
          type="radio"
          id="radio1"
          containerClass="mr-5"
        />
         </MDBFormInline>
             </div>
           
           
           
             <p className="text-center">
                {/* <MDBBtn color="secondary" onClick={this.handleSubmit} >ลงทะเบียน</MDBBtn> */}
                {this.state.radio === 1 ? 
                <><MDBBtn color="secondary" type='submit'>ลงทะเบียน</MDBBtn></>
                : <><MDBBtn color="secondary" type='submit' disabled >ลงทะเบียน</MDBBtn></>}
                
                </p>
           
          
           </div>
           
           </form>
           <MDBBtn color="mdb-color" type='submit' size="sm"><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn>


                        </MDBContainer>
                     </MDBJumbotron>
                   
                </MDBContainer>
                   
     
        )
    }
}
